import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ModulesService {

  //declare variables
  modules: any[] = [
    { 
      title: "Audits/Assessments",
      description: "Schedule and track audits to ensure that your compliance posture remains robust over time.",
      why: "As processes, people, and tools change over time, you expose the company to potential compliance risks.  Scheduling and ensuring audits are conducting allows you to reduce risk and to pro-actively identify problems before external auditors can find them.",
      link: "/documentation/assessments",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Assets",
      description: "Inventory and track your assets (desktop, laptops, servers, etc.) across their full lifecycle.",
      why: "You can't secure what you don't know you have.  Start by defining the assets within a security boundary to build out your security plan.",
      link: "/documentation/assets",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Case Management",
      description: "Track reported cases of potential non-compliance to investigate any complaint or incident.",
      why: "Manage investigative processes for Legal, Human Resources, Security, and other functional areas across their lifecycle to build timelines, track evidence, and document any non-compliances with policy.",
      link: "/documentation/cases",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Catalogues",
      description: "Laws or regulations that govern compliance programs.",
      why: "Provides a digital collection of controls/requirements for a given regulation that can be used by profiles and builders to create compliance programs.",
      link: "/documentation/catalog",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Causal Analysis",
      description: "Get to the root cause of issues to prevent recurrence.",
      why: "Just completing corrective actions isn't enough.  Rigorous causal analysis processes can assist organizations in holistically solving their problems to drive true performance improvement.",
      link: "/documentation/causalanalysis",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Components",
      description: "Lego style building blocks for composing security plans from the bottoms up.",
      why: "Instead of building monolithic security plans around a large boundary, you can organically compose a security plan from the bottoms up leveraging its discrete components for improved tracking and granularity.",
      link: "/documentation/components",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    },{ 
      title: "Data Calls",
      description: "Request information in support of audits or via formal correspondence.",
      why: "Ensure you have the audit support data you need, track due dates, and definitively know what data was provided to external parties.",
      link: "/documentation/datacalls",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Exceptions",
      description: "Approve circumstances where you can't efficiently meet a policy.",
      why: "Manage expiration dates, track risks, and drive down exceptions over time to improve your compliance posture.",
      link: "/documentation/exceptions",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Incidents",
      description: "Turbo-charge your incident response and react effectively when bad things happen.",
      why: "Securely respond to cyber, safety, or security related incidents in a secure and collaborative environment allowing you to get back to normal operations faster.",
      link: "/documentation/incidents",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Interconnections",
      description: "Manage the sharing of data between applications/systems to better understand data flow in your environment.",
      why: "Understand where your data moves, prevent leakage, and pro-actively authorize data exchanges to reduce risk.",
      link: "/documentation/interconnections",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Issues (POAMs)",
      description: "Pro-actively identify non-compliances, assign corrective actions, and track to closure.",
      why: "Adopt lean best practices for continuous improvement by constantly seeking to identify problems and improve your people, processes, and technology.",
      link: "/documentation/issues",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Policies",
      description: "Define organization rules and expectations while managing your policy lifecycle.",
      why: "Allows your organization to define the rules, document issues when they are not followed, and continuously improve them over time based on feedback and collaboration with users.",
      link: "/documentation/policies",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Projects",
      description: "Manage your portfolio of projects using light-weight tools to track cost, scope, and schedule.",
      why: "Improve accountability by tracking requirements, costs, milestones, issues, and risks to improve your overall portfolio management.",
      link: "/documentation/projects",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Questionnaires",
      description: "Dynamic builder allows customers to create and publish questionnaires on demand.",
      why: "Allows for vendor attestation, collection of data in support of audits/assessments, and for baselining programs as part of a risk assessment.",
      link: "/documentation/questionnaires",
      ce: 'fas fa-times-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Requirements",
      description: "Ensure you are meeting your contractual and regulatory obligations.",
      why: "Ensures full requirement flow-down and traceability to improve your organization's overall compliance posture resulting in lower audit risk.",
      link: "/documentation/requirements",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Risks",
      description: "Plan for the worst and develop effective mitigation strategies to protect your organization.",
      why: "Organizations that don't focus on managing and pro-actively mitigating risk won't have a long term future.",
      link: "/documentation/risks",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Security Controls",
      description: "Define policies for implementing cyber regulations, conduct testing, and attach evidence of compliance.",
      why: "Reduces risk of audit findings, avoids cyber breaches and associated reputation loss, and allow for continuous improvement of the cyber program over time.",
      link: "/documentation/securitycontrols",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Security Plans",
      description: "Define a system boundary, assign a collection of security controls, and govern related compliance data such as risks, issues/POAMS , and audits/assessments.",
      why: "Provides an effective organizing framework for ensuring compliance with cybersecurity regulations, managing work, and driving accountability.",
      link: "/documentation/securityplans",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Security Profiles",
      description: "Build automated templates that span multiple regulations while letting RegScale manage changes to regulations over time for you.",
      why: "Faster time to value for creating security plans, improved consistency between plans, and lower learning curves for new cyber security personnel.",
      link: "/documentation/securityprofiles",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, {
      title: "Supply Chain",
      description: "Manage contract lifecycles and related requirements and risks.",
      why: "Flow down requirements and manage 3rd party risks for subcontractors and suppliers.",
      link: "/documentation/supplychain",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Tasks",
      description: "Assign work to employees, track due dates, and schedule recurring work.",
      why: "Avoid compliance tasks falling through the cracks, drive accountability, and improve transparency on progress.",
      link: "/documentation/tasks",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }, { 
      title: "Threats",
      description: "Security environments are not static. Manage your response to new and emerging threats in real-time.",
      why: "Enables pro-active threat hunting, integrations with third party threat providers, and puts your cyber defenders on the offensive.",
      link: "/documentation/threats",
      ce: 'fas fa-check-circle fa-2x', 
      saas: 'fas fa-check-circle fa-2x', 
      ee: 'fas fa-check-circle fa-2x', 
      ms: 'fas fa-check-circle fa-2x'
    }
  ];

  //inject services
  constructor() {}

  //returns the list of modules
  getModuleList() {
    this.modules.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0);
    return this.modules;
  }

}
